
import {of as observableOf,  Observable } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

import { LoaderService } from "../../common/services/loader.service";
import { PaymentService } from "../../payments/services/payment.service";
import { PaymentSearchCriteria, PaymentStatus, PaymentType } from "../../payments/models/paymentItem.model";

@Injectable()
export class PaymentResolver  {
    constructor(public readonly paymentService: PaymentService, public readonly loaderService: LoaderService) {
    }

    resolve(route: ActivatedRouteSnapshot) : any | Observable<any> | Promise<any> {
        this.loaderService.toggleLoader(true);
        const organization = route.params.organizationId;
		const criteria = new PaymentSearchCriteria(organization, "", [PaymentStatus.Pending, PaymentStatus.Overdue, PaymentStatus.Partial], []);

        return this.paymentService.search(criteria).pipe(catchError((err) => this.handleError(err)), tap((data) => { this.loaderService.toggleLoader(false); }));
    }

    handleError(error: any): Observable<any> {
        return observableOf(error).pipe(tap((data) => {
            this.loaderService.toggleLoader(false);
        }));
    }
}